export default function CountryRestriction() {
  return (
    <section>
      <div className="h-screen w-screen bg-gray-100">
        <div className="h-full w-full">
          <div className="flex flex-col justify-center items-center h-full w-full">
            <div className="flex flex-col justify-center items-center p-8">
              <img src="/vibrato-logo-alt.svg" className="h-[60px] min-w-fit mb-8" />
              <div className="text-4xl text-center font-bold text-gray-700">
                Vibrato is only available in certain countries.
              </div>
              <div className="text-2xl font-normal text-gray-700 mt-4 max-w-2xl text-center">
                Unfortunately, we do not support your country at this time. Please contact us at{" "}
                <a className="underline" href="mailto:contact@getvibrato.com">
                  contact@getvibrato.com
                </a>{" "}
                for more information.
              </div>
              <div className="text-2xl font-normal text-gray-700 mt-4 max-w-2xl text-center">
                We are continually working to expand our services and hope to be available in your region soon.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
